import { Table, Typography } from "antd";
import { useSelector } from "react-redux";

const { Title } = Typography;

const format = (v) =>
  v === null || v === undefined
    ? ""
    : Number(v).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    });

const Section3_1_1 = ({ printMode = false }) => {
  const { data } = useSelector((state) => state.gstr3b);

  const backend = data?.section3_1_1 || [];

  const defaultRows = [
    {
      key: "i",
      label: (
        <>
          <b>(i)</b> Taxable supplies on which electronic commerce operator pays tax under Sub-section (5) of Section 9
          <br />
          <span style={{ color: "#666" }}>
            [To be furnished by the electronic commerce operator]
          </span>
        </>
      ),
    },
    {
      key: "ii",
      label: (
        <>
          <b>(ii)</b> Taxable supplies made by the registered person through electronic commerce operator, on which electronic commerce operator is required to pay tax under Sub-section (5) of Section 9
          <br />
          <span style={{ color: "#666" }}>
            [To be furnished by the registered person making supplies through electronic commerce operator]
          </span>
        </>
      ),
    },
  ];

  const finalData = defaultRows.map((row) => {
    const match = backend.find((item) => item.key === row.key) || {};
    return {
      ...row,
      taxable: match.taxable ?? 0,
      igst: match.igst ?? 0,
      cgst: match.cgst ?? 0,
      sgst: match.sgst ?? 0,
      cess: match.cess ?? 0,
    };
  });

  const columns = [
    {
      title: "Description",
      dataIndex: "label",
      width: "50%",
    },
    {
      title: "Taxable Value",
      dataIndex: "taxable",
      align: "right",
      render: (v) => format(v),
    },
    {
      title: "Integrated Tax",
      dataIndex: "igst",
      align: "right",
      render: (v) => format(v),
    },
    {
      title: "Central Tax",
      dataIndex: "cgst",
      align: "right",
      render: (v) => format(v),
    },
    {
      title: "State/UT Tax",
      dataIndex: "sgst",
      align: "right",
      render: (v) => format(v),
    },
    {
      title: "CESS Tax",
      dataIndex: "cess",
      align: "right",
      render: (v) => format(v),
    },
  ];

  return (
    <>
      <Title level={5}>
        3.1.1 Details of supplies notified under sub-section (5) of section 9
      </Title>

      <Table
        columns={columns}
        dataSource={finalData}
        pagination={false}
        bordered
        rowKey="key"
        scroll={printMode ? undefined : { x: 900 }}
      />
    </>
  );
};

export default Section3_1_1;